export default __webpack_public_path__ + "static/media/play-circle.e0033e40.svg";